<app-panel-body>
  <div class="flex min-h-0 flex-1 flex-col" *transloco="let t; prefix: 'trip-finances.panels.budget'">
    <div class="min-h-0 flex-1 overflow-y-auto">
      <app-content-container>
        <p class="text-sm text-primary-text-light">{{ t('description') }}</p>

        <div class="flex justify-end">
          <button
            type="button"
            class="btn btn-primary btn-no-grow flex items-center gap-2"
            (click)="addBudgetItem()"
          >
            <fa-icon [icon]="['far', 'plus']" />
            {{ t('add') }}
          </button>
        </div>

        <app-simple-table
          [data]="budget()"
          [columns]="columns()"
          trackByKey="id"
          [sortingEnabled]="true"
          [filteringEnabled]="false"
          [cards]="true"
          rowLabel="description"
        >
          <ng-template #actions let-row>
            <fa-icon [icon]="['far', 'pencil']" (click)="editBudgetItem(row)" class="cursor-pointer text-primary" />
            <fa-icon [icon]="['far', 'trash']" (click)="deleteBudgetItem(row)" class="cursor-pointer text-danger" />
          </ng-template>
        </app-simple-table>

        <div class="space-y-1 text-right font-semibold">
          <div>{{ t('total-budget') }}: {{ groupExpensesTotal() | currency }}</div>
          <div class="text-sm font-normal text-primary-text-light">
            {{ t('per-person-basis', { count: perPersonBasis() }) }}
          </div>
        </div>
      </app-content-container>
    </div>
  </div>
</app-panel-body>
